import { Controller } from "@hotwired/stimulus"

// Usado em dois contextos:
// 1. Em <form>: escuta turbo:submit-start/end e desabilita o [type=submit].
// 2. Em links/botões com turbo-method: escuta click e aplica estado de loading.
export default class extends Controller {
  static values = { label: String }

  // Contexto 1: form com Turbo
  submit() {
    const btn = this.#submitButton()
    if (!btn) return
    this._originalLabel = btn.innerHTML
    btn.disabled = true
    btn.innerHTML = this.labelValue || "Aguarde..."
  }

  submitEnd(event) {
    if (event.detail?.success) return
    this.#restore()
  }

  // Contexto 2: link/botão avulso (turbo-method ou onclick)
  click(event) {
    if (this.element.dataset.loading) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    this.element.dataset.loading = "1"
    this.element.style.pointerEvents = "none"
    this.element.style.opacity = "0.6"
    const label = this.labelValue || "Aguarde..."
    Array.from(this.element.childNodes)
      .filter(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length > 0)
      .forEach(n => { n.textContent = ` ${label}` })
  }

  #submitButton() {
    return this.element.querySelector('[type="submit"]')
  }

  #restore() {
    const btn = this.#submitButton()
    if (!btn || !this._originalLabel) return
    btn.disabled = false
    btn.innerHTML = this._originalLabel
  }
}
